import { useLocation } from "@reach/router"
import { Layout as AntLayout, Popover } from "antd"
import "antd/dist/antd.css"
import React, { useEffect, useState } from "react"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Helmet } from "react-helmet"
import { BsRobot } from "react-icons/bs"
import { RxCross2 } from "react-icons/rx"
import { RecoilRoot } from "recoil"
import TalkToUs from "../components/Talktous"
import "../styles/layout.scss"
import Chat from "./Chat"
import Footer from "./Footer"
import Header from "./Header"
const Layout = ({ children, className, data, style, pageTitle, descrip }) => {
  const { Content } = AntLayout
  const location = useLocation()
  const [cookieModal, setCookieModal] = useState(true)
  const [user, setUser] = useState(null)
  const [botChat, setBotChat] = useState(false)
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true);
    }, 1000)
  }, [])


  const acceptCookie = () => {
    setCookieModal(false)
    localStorage.setItem("user", true)
  }
  const declineCookie = () => {
    setCookieModal(false)
    JSON.stringify(localStorage.setItem("user", false))
  }
  useEffect(() => {
    if (window !== undefined) {
      setUser(localStorage.getItem("user"))
    }
  }, [])
  const functionCallHandler = async (call) => {
    const args = JSON.parse(call.function.arguments);
    //make api call for odoo
    const response = await fetch(
      `https://staging.visiomate.com/create_consultancy/ai_query`,
      {
        method: "POST",
        body: JSON.stringify(args),
      }
    );
    let data = await response.text();
    return JSON.stringify(data);
  };
  return (
    <RecoilRoot>
      <AntLayout>
        <title>{pageTitle}</title>
        <Helmet>
          <meta name="description" content={descrip} />
          <link
            rel="canonical"
            href={`${location.href}`}
            key="canonical-link"
          />
        </Helmet>
        <Header data={data} />
        {cookieModal && user === null && (
          <div className="cookie_div">
            <p className="cookie_text">
              This site uses cookies and related technologies, as described in
              our privacy policy, for purposes that may include site operation,
              analytics, enhanced user experience, or advertising. You may
              choose to consent to our use of these technologies, or manage your
              own preferences.
            </p>
            <div className="cookie_buttons">
              <button
                className="cookie_button accept_btn"
                onClick={acceptCookie}
              >
                Accept
              </button>
              <button
                className="cookie_button decline_btn"
                onClick={declineCookie}
              >
                Decline
              </button>
            </div>
          </div>
        )}
        <div
          style={{ position: "fixed", bottom: "10px", right: "15px", zIndex: 1100 }}
        >
          <div style={{ position: "relative" }}>
            {!!showPopup && <div className='opener'>
              <span>Do you have any question? 😀</span>
              <span>Visiomate's team is online</span>
              <button className='chatbtn' onClick={() => {
                setBotChat(true);
              }}>Chat with Visiomate's Team</button>
              <button onClick={(e) => {
                e.preventDefault();
                setShowPopup(false);
              }} className='popup-close'><RxCross2 /></button>
            </div>}
            <button
              className="accept_btn cookie_button bot-button"
              style={{ borderRadius: '50% !important' }}
              onClick={(e) => {
                e.preventDefault()
                setShowPopup(false);
                setBotChat(!botChat)
              }}
            >
              <p className="botPara">
                {!botChat ? <BsRobot className="botIcon" /> : <RxCross2 className="botIcon" />}
              </p>
            </button>
            {botChat && <Chat functionCallHandler={functionCallHandler} setBotChat={setBotChat} />}
          </div>
        </div>
        <Content className={className} style={style}>
          {children}
        </Content>
        {/* {!(
          location.pathname.includes("privacypolicy") ||
          location.pathname.includes("userdeletionpolicy")
        ) && <TalkToUs />} */}
        <Footer data={data} />
      </AntLayout>
    </RecoilRoot>
  )
}

export default Layout
